import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import PropertyAppResource from "./PropertyAppResource";
import PropertyContactAppResource from "./PropertyContactAppResource";

class PropertyContactNoteAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'property-contact-note';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'notes';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'created_at',
      'updated_at',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'propertyContactUuid',
      'note',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      propertyContact: PropertyContactAppResource
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      propertyContact: 'propertyContactUuid'
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      note: {
        type: 'string',
        presence: true
      }
    };
  }

}

export default PropertyContactNoteAppResource;
